/* eslint-disable no-shadow */
import React from 'react';
import { useSelector } from 'react-redux';

import OfficialsList from './OfficialsList';
import styles from '../drawEdit.scss';

const OfficialsTabV2 = () => {
    const drawEdit = useSelector(({ drawEdit }) => drawEdit);
    const { officials } = drawEdit;

    return (
        <div className={`${styles.section} bg-transparent main-content`}>
            <div className={`container mt32 bg-transparent`}>
                <div className="row">
                    {officials?.loading && (
                        <div className="col-12">
                            <div data-testid="draw-edit.officials.loading">Loading...</div>
                        </div>
                    )}
                    {officials?.error && (
                        <div className="col-12">
                            <div data-testid="draw-edit.officials.error">Error loading officials...</div>
                        </div>
                    )}
                    {officials.data && (
                        <div className="col-12 col-md-6 offset-md-3">
                            <OfficialsList />
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default OfficialsTabV2;
